import React, {useState} from "react";
import {Chip, Grid, TextField, Typography} from "@mui/material";

interface ChipTextFieldProps {
    value: string | number | null
    multiline?: boolean
    rows?: number
    onChange: (value: string) => void
    label: string
    size?: number
    type?: "text" | "number"
    disabled?: boolean
}

export const ChipTextField: React.FC<ChipTextFieldProps> = ({label, onChange, value, rows=0, multiline=false, size = 12, type='text', disabled = false}) => {
    const [editMode, setEditMode] = useState<boolean>(false)

    return (
        <Grid container size={{ xs: size }} rowGap={0.6}>
            <Grid size={{ xs: 12 }}>
                <Typography
                    variant="body1"
                    sx={{
                        alignContent: "center",
                        height: "100%",
                        color: "#fff",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {label}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                {editMode ? (
                    <TextField
                        type={type}
                        size="small"
                        autoFocus
                        rows={rows}
                        multiline={multiline}
                        value={value}
                        disabled={disabled}
                        onChange={(e) => onChange(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        onBlur={(e) => {
                            setEditMode(false);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                setEditMode(true)
                                e.stopPropagation();
                            }
                        }}
                        sx={{ borderRadius: 2, input: { color: "#fff" }, width: "100%" }}
                        variant="standard"
                    />
                ) : (
                    <Chip
                        label={value || ""}
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setEditMode(true)
                        }}
                        sx={{
                            width: "100%",
                            height: 22,
                            color: "#fff",
                            cursor: "pointer",
                            backgroundColor: 'transparent',
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: 'flex-start',
                            alignContent: 'flex-start'
                        }}
                    />
                )}
            </Grid>
        </Grid>
    )
}